<template>
  <el-dialog
    title="课题全部标签"
    custom-class="field-editor-modal"
    :visible.sync="visible"
    width="760px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="field-editor" v-loading="modalLoading">
      <div class="field-group-ul">
        <template v-for="groupItem in groupByFields">
          <div class="field-group-item" v-if="groupItem.list.length > 0" :key="groupItem.type">
            <div class="field-group-title">
              <span>{{ groupItem.label }}</span>
              <template v-if="['text', 'dict'].includes(groupItem.type)">
                <div v-if="textCheckGroup.type === groupItem.type && textCheckGroup.visible" class="field-group-checks">
                  <el-checkbox
                    :value="textCheckGroup.checks.length === groupItem.list.length"
                    @change="val => allCheckHandle(val, groupItem.list)"
                  >
                    <span>全选</span>
                  </el-checkbox>
                  <span class="field-group-check-count">
                    <span>已选择</span>
                    <span class="field-group-check-count-num">{{ textCheckGroup.checks.length }}</span>
                    <span>项</span>
                  </span>
                  <el-popover
                    placement="bottom"
                    title=""
                    width="280"
                    trigger="click"
                    :disabled="textCheckGroup.checks.length < 1"
                    popper-class="field-group-popover"
                    ref="fieldGroupMergePopoverRef"
                  >
                    <el-button
                      type="primary"
                      size="mini"
                      slot="reference"
                      class="field-group-check-btn"
                      :disabled="textCheckGroup.checks.length < 2"
                    >
                      <span>合并至分类标签</span>
                    </el-button>
                    <div class="field-group-popover-container">
                      <div class="field-group-popover-title">合并至分类标签</div>
                      <div class="field-group-popover-desc single-ellipsis">
                        <span>合并标签：{{ mergeFieldName }}</span>
                      </div>
                      <div class="field-group-popover-form">
                        <el-input v-model="textCheckGroup.fieldName" placeholder="请输入分类标签名称" />
                        <div class="field-group-popover-form-btn">
                          <el-button @click="$refs.fieldGroupMergePopoverRef[0].doClose()">
                            <span>取消</span>
                          </el-button>
                          <el-button type="primary" :loading="textCheckGroup.loading" @click="mergeDictFieldHandle()">
                            <span>确认</span>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                  <el-popover
                    placement="bottom"
                    title=""
                    width="280"
                    trigger="click"
                    :disabled="textFieldList.length < 1 || textCheckGroup.checks.length < 1"
                    popper-class="field-group-popover"
                    ref="fieldGroupMovePopoverRef"
                    v-if="textCheckGroup.type === 'text'"
                  >
                    <el-button
                      type="primary"
                      plain
                      size="mini"
                      slot="reference"
                      class="field-group-check-btn"
                      :disabled="textFieldList.length < 1 || textCheckGroup.checks.length < 1"
                    >
                      <div class="field-group-popover-container">转入标签</div>
                    </el-button>
                    <div class="field-group-popover-container" v-loading="textCheckGroup.loading">
                      <div class="field-group-popover-title">请选择转入标签</div>
                      <div class="field-group-popover-desc single-ellipsis">
                        <span>标签：{{ mergeFieldName }}</span>
                      </div>
                      <div class="field-group-popover-dict-ul">
                        <div
                          class="field-group-popover-dict-li"
                          v-for="fieldItem in textFieldList"
                          :key="fieldItem._id"
                          @click="moveToFieldHandle(fieldItem)"
                        >
                          <span>{{ fieldItem.title }}</span>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                  <el-button size="mini" @click="textCheckGroup.visible = false" class="field-group-check-btn">
                    <span>取消</span>
                  </el-button>
                </div>
                <el-button
                  type="text"
                  :style="{ padding: 0 }"
                  v-show="!textCheckGroup.visible"
                  @click="textCheckGroup.init(groupItem.type)"
                >
                  <span>合并</span>
                </el-button>
              </template>
            </div>
            <div class="field-list">
              <div class="field-item" v-for="fieldItem in groupItem.list" :key="fieldItem._id">
                <div class="field-item-container" :class="fieldItem.deputy_type || ''" @click="expandHandle(fieldItem)">
                  <img :src="groupItem.img" class="field-item-img" />
                  <div class="field-item-title single-ellipsis">{{ fieldItem.title }}</div>
                  <div class="field-item-tools">
                    <el-checkbox
                      v-model="textCheckGroup.checks"
                      :label="fieldItem"
                      v-if="textCheckGroup.visible && groupItem.type === textCheckGroup.type"
                    >
                      <span></span>
                    </el-checkbox>
                    <el-tooltip placement="top" :content="isCourseMode ? '加入当前课题' : '加入当前研究点'" v-else>
                      <i
                        class="el-icon-plus handle-icon add-btn"
                        v-if="!checkIds[fieldItem._id]"
                        @click.stop="addFieldHandle(fieldItem)"
                      ></i>
                    </el-tooltip>
                    <template v-if="fieldItem.deputy_type === 'dict'">
                      <i class="el-icon-arrow-up handle-icon expand-btn" v-if="expandEnum[fieldItem._id]"></i>
                      <i class="el-icon-arrow-down handle-icon expand-btn" v-else></i>
                    </template>
                    <el-dropdown
                      @command="unit => changeUnitDefaultHandle(unit, fieldItem)"
                      v-if="
                        (fieldItem.type === 'num' && (fieldItem.numClassifyUnit || []).length > 0) ||
                          (sysFieldUnitEnum[fieldItem.deputy_type] || []).length > 0
                      "
                    >
                      <span :style="{ marginLeft: '8px', cursor: 'pointer', fontSize: '12px' }">
                        <span>{{ fieldItem.numUnitDefault || '' }}</span>
                        <i class="el-icon-arrow-down handle-icon expand-btn"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-for="unitItem in getUnitList(fieldItem, sysFieldUnitEnum)"
                          :key="unitItem.unit"
                          :command="unitItem.unit"
                          :disabled="unitItem.unit === fieldItem.numUnitDefault"
                        >
                          <span :style="{ fontSize: '12px' }">{{ unitItem.unit }}</span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div
                  class="field-item-child-content"
                  v-if="fieldItem._id in expandEnum"
                  v-show="expandEnum[fieldItem._id]"
                  @click.stop
                >
                  <fieldDictLazyList :fieldItem="fieldItem" haveTools :ref="`fieldDictLazyRef_${fieldItem._id}`">
                    <el-button
                      v-if="false"
                      type="text"
                      class="transform-btn"
                      slot="tools"
                      slot-scope="{ dictItem }"
                      @click="transformToTextHandle(dictItem, fieldItem)"
                    >
                      <span>转为一般标签</span>
                    </el-button>
                  </fieldDictLazyList>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <span slot="footer">
      <el-tooltip effect="dark" content="当前内容已保存" placement="top">
        <el-button @click="visible = false">
          <span>关闭</span>
        </el-button>
      </el-tooltip>
    </span>
  </el-dialog>
</template>

<script>
import fieldDictLazyList from '@/components/fieldDictLazyList';
import { services } from '@/service';
import { uniqBy } from 'lodash';
import {
  groupByFieldFilter,
  formatColumnToFormInfo,
  transformColumnToSource,
  initColumns,
  upgradeFieldForCourse
} from '@/lib/utils';

export default {
  components: { fieldDictLazyList },
  data() {
    return {
      fields: [],
      modalLoading: false,
      groupByFields: [],
      savePromises: [],
      newCourseDetail: null,
      expandEnum: {},
      textCheckGroup: {
        visible: false,
        type: '',
        checks: [],
        fieldName: '',
        loading: false,
        init: function(type) {
          this.type = type;
          this.checks = [];
          this.fieldName = '';
          this.visible = true;
        }
      },
      sysFieldUnitEnum: {}
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    courseDetail: {
      type: Object,
      required: true
    },
    researchModel: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      async set(val) {
        if (val || this.modalLoading) {
          return;
        }
        try {
          this.modalLoading = true;
          if (this.savePromises.length > 0) {
            await Promise.all(this.savePromises);
            this.$emit('success', this.newCourseDetail);
          }
        } catch (err) {
          this.$error(err);
        } finally {
          this.modalLoading = false;
        }
        this.$emit('update:show', val);
      }
    },
    isCourseMode() {
      return !this.researchModel;
    },
    checkIds() {
      const ids = {};
      this.fields.forEach(item => {
        ids[item._id] = true;
      });
      return ids;
    },
    textFieldList() {
      const list = [];
      this.groupByFields.forEach(groupItem => {
        if (['text', 'dict'].includes(groupItem.type)) {
          list.push(...groupItem.list);
        }
      });
      const ids = this.textCheckGroup.checks.map(o => o._id);
      return list.filter(fieldItem => !ids.includes(fieldItem._id));
    },
    mergeFieldName() {
      return this.textCheckGroup.checks.map(o => o.title).join('、');
    }
  },
  created() {
    if (this.isCourseMode) {
      this.fields = [...this.courseDetail._source.fields];
    } else {
      this.fields = [...this.researchModel.fields];
    }
  },
  mounted() {
    this.initHandle();
  },
  methods: {
    getUnitList(fieldItem, sysFieldUnitEnum) {
      if ((fieldItem.numClassifyUnit || []).length > 0) {
        return fieldItem.numClassifyUnit;
      }
      return sysFieldUnitEnum[fieldItem.deputy_type] || [];
    },
    allCheckHandle(val, list) {
      if (val) {
        this.textCheckGroup.checks = list.map(o => o._id);
      } else {
        this.textCheckGroup.checks = [];
      }
    },
    async initHandle() {
      try {
        this.modalLoading = true;
        const [courseFields, sysFieldUnitEnum] = await Promise.all([
          services.courseware.getFields(this.courseDetail._id),
          services.courseware.getSysFieldUnit()
        ]);

        this.sysFieldUnitEnum = sysFieldUnitEnum;
        this.groupByFields = groupByFieldFilter(courseFields);
      } catch (err) {
        this.$error(err);
      } finally {
        this.modalLoading = false;
      }
    },
    expandHandle(fieldItem) {
      if (fieldItem.deputy_type !== 'dict') {
        return;
      }
      if (!(fieldItem._id in this.expandEnum)) {
        this.$set(this.expandEnum, fieldItem._id, true);
      } else {
        this.expandEnum[fieldItem._id] = !this.expandEnum[fieldItem._id];
      }
    },
    addFieldHandle(fieldItem) {
      this.fields.push(fieldItem);
      this.upgradeFields();
    },
    upgradeFields() {
      const courseDetail = this.newCourseDetail || this.courseDetail;

      let newCourseSource = null;
      if (this.isCourseMode) {
        newCourseSource = {
          ...courseDetail._source,
          fields: this.fields
        };
      } else {
        const charts = [...courseDetail._source.chart];
        const index = charts.findIndex(chartItem => chartItem.index_id === this.researchModel.index_id);
        charts.splice(index, 1, { ...this.researchModel, fields: this.fields });
        newCourseSource = {
          ...courseDetail._source,
          chart: charts
        };
      }
      this.newCourseDetail = { ...courseDetail, _source: newCourseSource };

      this.savePromises.push(services.courseware.saveCourseware(this.courseDetail._id, newCourseSource));
    },
    async transformToTextHandle(dictItem, fieldItem) {
      this.$confirm(`转为一般标签后自动删除该分类，请问是否继续？`, '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action !== 'confirm') {
            done();
            return;
          }
          try {
            instance.confirmButtonLoading = true;

            const typeList = services.labelRelation.getEntityRelationGroup();
            const childEl = this.$refs[`fieldDictLazyRef_${fieldItem._id}`][0];
            const newFieldId = `${this.$store.getters.userInfo.id}_${Date.now()}`;

            let newFieldSource = transformColumnToSource({
              info: formatColumnToFormInfo({ title: dictItem.labelName, word: dictItem.children, calculator_type: 1 }),
              typeList
            });
            newFieldSource = {
              ...newFieldSource,
              ownerId: this.$store.getters.userInfo.id,
              create_time: newFieldSource.update_time,
              coursewareId: this.courseDetail._id,
              parentId: '',
              field_name: newFieldId,
              full_path: newFieldId,
              full_name: newFieldSource.chinese_name,
              groups: this.courseDetail._source.instrumentType,
              system: false
            };

            await services.courseware.addField(newFieldId, newFieldSource);

            const newFieldItem = initColumns([
              {
                _id: newFieldId,
                child_count: 0,
                _source: { ...newFieldSource }
              }
            ])[0];

            const newDictClassifyValue = childEl.getDictValueForParent().filter(item => {
              return item.labelName !== dictItem.labelName;
            });

            await Promise.all([
              services.courseware.updField(fieldItem._id, {
                dictValue: newDictClassifyValue.slice(0, 6).map(o => o.labelName),
                dictClassifyValue: newDictClassifyValue,
                sys_id: ''
              }),
              services.caseRule.autuAddTag({
                courseId: this.courseDetail._id,
                courseTitle: this.courseDetail._source.title,
                dataSource: JSON.stringify({ query: [] }),
                fieldDetailArr: [newFieldItem],
                runType: '追加'
              })
            ]);

            fieldItem.sys_id = '';
            fieldItem.dictClassifyValue = newDictClassifyValue.slice(0, 6);
            fieldItem.dictValue = fieldItem.dictClassifyValue.map(o => o.labelName);

            const textGroupItem = this.groupByFields.find(o => o.type === 'text');
            textGroupItem.list.push(newFieldItem);

            this.$message.success('标签转换成功');
            childEl.fetchDictHandle();

            done();
          } catch (err) {
            this.$error(err);
          } finally {
            instance.confirmButtonLoading = false;
          }
        }
      });
    },
    async mergeDictFieldHandle() {
      const fieldName = this.textCheckGroup.fieldName.trim();
      if (!fieldName) {
        this.$message.warning('请输入需要合并后的标签名称');
        return;
      }
      try {
        this.textCheckGroup.loading = true;

        const transformType = this.textCheckGroup.type === 'text' ? 'text_add_text' : 'dict_add_dict';

        const typeList = services.labelRelation.getEntityRelationGroup();
        const newFieldId = `${this.$store.getters.userInfo.id}_${Date.now()}`;
        const checks = this.textCheckGroup.checks;
        const fieldsIds = checks.map(o => o._id);

        let dictClassifyValue = [];
        if (transformType === 'text_add_text') {
          const dictLabelNameArr = [...new Set(checks.map(o => o.title))];
          dictClassifyValue = dictLabelNameArr.map(text => {
            return { labelName: text, children: '' };
          });
        } else {
          const fieldsDictResult = await services.caseRule.getFieldsDictVal(fieldsIds);
          const labelNameEnum = {};
          const formatChildrenArr = (children = '') =>
            children
              .split('|')
              .map(text => text.trim())
              .filter(text => !!text);
          Object.keys(fieldsDictResult).forEach(fieldId => {
            (fieldsDictResult[fieldId].dictClassifyValue || []).forEach(dictClassifyItem => {
              if (labelNameEnum[dictClassifyItem.labelName]) {
                labelNameEnum[dictClassifyItem.labelName].children = [
                  ...new Set([
                    ...formatChildrenArr(labelNameEnum[dictClassifyItem.labelName].children),
                    ...formatChildrenArr(dictClassifyItem.children)
                  ])
                ].join('|');
              } else {
                labelNameEnum[dictClassifyItem.labelName] = { ...dictClassifyItem };
                dictClassifyValue.push(labelNameEnum[dictClassifyItem.labelName]);
              }
            });
          });
        }

        let newFieldSource = transformColumnToSource({
          info: formatColumnToFormInfo({
            title: fieldName,
            deputy_type: 'dict'
          }),
          typeList
        });
        newFieldSource = {
          ...newFieldSource,
          ownerId: this.$store.getters.userInfo.id,
          dictClassifyValue,
          dictValue: dictClassifyValue.slice(0, 6).map(o => o.labelName),
          create_time: newFieldSource.update_time,
          coursewareId: this.courseDetail._id,
          parentId: '',
          field_name: newFieldId,
          full_path: newFieldId,
          full_name: newFieldSource.chinese_name,
          groups: this.courseDetail._source.instrumentType,
          system: false
        };

        await services.courseware.addField(newFieldId, newFieldSource);

        const newFieldItem = initColumns([
          {
            _id: newFieldId,
            child_count: 0,
            _source: { ...newFieldSource }
          }
        ])[0];

        await services.labelRelation.fieldChangeMove({
          transform_type: transformType,
          coursewareId: this.courseDetail._id,
          field_name: newFieldItem.field_name,
          history_labels: checks.map(o => {
            return {
              labelId: o._id,
              field_name: o.field_name,
              chinese_name: o.title
            };
          })
        });

        const textGroupItem = this.groupByFields.find(o => o.type === 'dict');
        textGroupItem.list.unshift(newFieldItem);

        this.$message.success('标签合并成功');
        this.textCheckGroup.visible = false;
        this.$refs.fieldGroupMergePopoverRef[0].doClose();

        this.fields = this.fields.filter(o => !fieldsIds.includes(o._id));

        this.addFieldHandle(newFieldItem);
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.textCheckGroup.loading = false;
      }
    },
    async moveToFieldHandle(fieldItem) {
      try {
        this.textCheckGroup.loading = true;

        const checks = this.textCheckGroup.checks;
        const isDictFiled = fieldItem.deputy_type === 'dict';

        const transformType = isDictFiled ? 'text_to_dict' : 'text_to_text';

        await services.labelRelation.fieldChangeMove({
          transform_type: transformType,
          coursewareId: this.courseDetail._id,
          field_name: fieldItem.field_name,
          history_labels: checks.map(o => {
            return {
              labelId: o._id,
              field_name: o.field_name,
              chinese_name: o.title
            };
          })
        });

        this.$message.success('标签转入成功');
        this.textCheckGroup.visible = false;
        this.$refs.fieldGroupMovePopoverRef[0].doClose();

        if (isDictFiled) {
          const { data } = await services.caseRule.getFieldDictVal({
            labelId: fieldItem._id,
            keyword: '',
            courseId: '',
            size: 10000
          });
          const newDictClassifyValue = uniqBy(
            [
              ...(data.dict_classify_value || []),
              ...checks.map(o => {
                return { labelName: o.title };
              })
            ],
            'labelName'
          );
          await services.courseware.updField(fieldItem._id, {
            dictValue: newDictClassifyValue.slice(0, 6).map(o => o.labelName),
            dictClassifyValue: newDictClassifyValue,
            sys_id: ''
          });

          fieldItem.sys_id = '';
          fieldItem.dictClassifyValue = newDictClassifyValue.slice(0, 6);
          fieldItem.dictValue = fieldItem.dictClassifyValue.map(o => o.labelName);

          const courseDetail = this.newCourseDetail || this.courseDetail;

          const newCourseSource = upgradeFieldForCourse(fieldItem, courseDetail);

          this.newCourseDetail = { ...courseDetail, _source: newCourseSource };

          this.savePromises.push(services.courseware.saveCourseware(this.courseDetail._id, newCourseSource));

          const childElArr = this.$refs[`fieldDictLazyRef_${fieldItem._id}`];
          childElArr && childElArr[0] && childElArr[0].fetchDictHandle();
        }

        const ids = checks.map(o => o._id);

        this.fields = this.fields.filter(o => !ids.includes(o._id));

        const fieldIdx = this.fields.findIndex(o => o._id === fieldItem._id);
        if (fieldIdx === -1) {
          this.addFieldHandle(fieldItem);
        } else {
          this.upgradeFields();
        }
      } catch (err) {
        this.$message.error(err);
      } finally {
        this.textCheckGroup.loading = false;
      }
    },
    async changeUnitDefaultHandle(unit, fieldItem) {
      await this.$confirm('是否确认切换标签默认计量单位？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      const oldNumClassifyUnit = fieldItem.numClassifyUnit || [];
      const oldNumUnitDefault = fieldItem.numUnitDefault;
      try {
        fieldItem.numClassifyUnit = oldNumClassifyUnit.map(unitItem => {
          return { ...unitItem, default: unit === unitItem.unit };
        });
        fieldItem.numUnitDefault = unit;

        await services.courseware.updField(fieldItem._id, {
          numClassifyUnit: fieldItem.numClassifyUnit,
          numUnitDefault: fieldItem.numUnitDefault
        });

        await services.courseware.transformNumFieldValue(this.courseDetail._id, fieldItem._id, oldNumUnitDefault, unit);

        const courseDetail = this.newCourseDetail || this.courseDetail;

        const newCourseSource = upgradeFieldForCourse(fieldItem, courseDetail);

        this.newCourseDetail = { ...courseDetail, _source: newCourseSource };

        this.savePromises.push(services.courseware.saveCourseware(this.courseDetail._id, newCourseSource));
      } catch (err) {
        fieldItem.numClassifyUnit = oldNumClassifyUnit;
        fieldItem.numUnitDefault = oldNumUnitDefault;
        this.$error(err);
      }
    }
  }
};
</script>

<style lang="scss">
.field-editor-modal {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.field-group-popover {
  .field-group-popover-container {
    .field-group-popover-title {
      color: #2c3443;
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
      padding: 14px 14px 5px;
    }

    .field-group-popover-desc {
      color: #9599a5;
      font-size: 12px;
      line-height: 17px;
      padding: 0 14px 8px;
    }

    .field-group-popover-form {
      padding: 6px 14px 20px;

      .field-group-popover-form-btn {
        margin-top: 40px;
        text-align: right;
      }
    }

    .field-group-popover-dict-ul {
      box-sizing: border-box;
      max-height: 220px;
      overflow: auto;
      border-top: 1px solid #e8ebef;
      padding: 8px 0;
      margin-top: 8px;

      .field-group-popover-dict-li {
        color: #2c3443;
        font-size: 14px;
        line-height: 28px;
        padding: 0 14px;
        cursor: pointer;

        &:hover {
          background-color: #eaf6ff;
        }
      }

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.field-editor {
  min-height: 300px;
  max-height: 60vh;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .field-group-ul {
    .field-group-item {
      margin: 10px 0;
      .field-group-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #2c3443;
        font-size: 14px;
        height: 25px;
        font-weight: bold;
        padding: 0px 20px;

        & > span {
          font-weight: inherit;
        }

        .field-group-checks {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #3d465a;

          ::v-deep .el-checkbox {
            .el-checkbox__label {
              font-size: 12px;
              color: #3d465a;
            }
          }

          .field-group-check-count {
            position: relative;
            margin-left: 10px;
            padding-left: 11px;

            &::before {
              content: ' ';
              position: absolute;
              left: 0;
              top: 0px;
              width: 1px;
              height: 12px;
              background-color: #9599a5;
            }

            .field-group-check-count-num {
              color: #1991fb;
              font-weight: bold;
              margin: 0 3px;
            }
          }

          .field-group-check-btn {
            margin-left: 10px;
          }
        }
      }

      .field-list {
        .field-item {
          .field-item-container {
            display: flex;
            align-items: center;
            color: #2c3443;
            font-size: 12px;
            line-height: 28px;
            min-height: 28px;

            &.dict {
              cursor: pointer;
            }
            .field-item-img {
              width: 16px;
              margin-right: 6px;
              margin-left: 20px;
            }
            .field-item-title {
              flex: 1;
              width: 0;
            }
            .field-item-tools {
              display: flex;
              align-items: center;
              margin-left: 6px;
              margin-right: 20px;

              .handle-icon {
                font-size: 14px;
                color: #1991fb;
                padding: 4px;
                cursor: pointer;
                margin-left: 4px;

                &.add-btn {
                  font-size: 16px;
                }

                &.expand-btn {
                  color: #9599a5;
                }
              }
            }
            &:hover {
              background-color: #eaf6ff;
            }
          }
          .field-item-child-content {
            box-sizing: border-box;
            width: 100%;
            padding: 0 20px;
            background-color: #fff;

            .transform-btn {
              padding: 0;
              .transform-btn-img {
                width: 16px;
                margin-right: 4px;
                vertical-align: bottom;
              }
            }
          }
        }
      }
    }
  }
}
</style>
